import React from 'react';
import { Form, FormGroup, Col, Row } from 'react-bootstrap';
import './style.scss';
import LoadingSpinner from '../LoadingSpinner';
import reelImage from './Reel.png'
import sheetImage from './Sheet.png'
import * as Convert from '../util/unitConversion';


class ProductInfo extends React.Component {
  constructor(props) {
    super(props);
    //this.labelAndText = this.labelAndText.bind(this);
    this.getData = this.getData.bind(this);
    this.getSpec1 = this.getSpec1.bind(this);
    this.getSpec2 = this.getSpec2.bind(this);
    this.getGrammageLabel = this.getGrammageLabel.bind(this);
    this.commonPropertyMap = {
      PRODUCT_CODE: "Product code",
      PRODUCT_DESCRIPTION: "Description",
      PT_DESCRIPTION: 'Product type description',
      GRADE_CODE: "Quality",
      BASIS_WEIGHT_UC: <Convert.TextTo value_metric={this.getGrammageLabel()} value_imperial={"Basis Weight"}/>,//()=>{return (<p>Grammage (g/m<sup>2</sup>)</p>)},//this.getGrammageLabel(), //"<p>Grammage (g/m<sup>2</sup>)</p>",
      END_USE_CODE: "Usage code",
      END_USE_DESCRIPTION: "Usage description"
    }

    this.rollPropertyMap = {
      PACKING_CODE: "Packing code",
      PALLET_CODE: "Pallet code",
      PWMC_DESCRIPTION: "Pallet wrap material",
      ROLLS_PER_PALLET: "Rolls per pallet",
      ROLL_STACKS_PER_PALLET: "Stacks per pallet",
      NET_WEIGHT_ROUNDED: "Net weight",
      NET_HEIGHT_ROUNDED: "Net height",
      NET_WEIGHT_UC: <Convert.AddUnit value={"Net weight"} unit_metric={" (kg)"} unit_imperial={" (lb)"}/>,
      NET_HEIGHT_UC: <Convert.AddUnit value={"Net height"} unit_metric={" (mm)"} unit_imperial={" (in)"}/>
    }
    this.sheetPropertyMap = {
      PACKING_CODE: "Packing code",
      PALLET_CODE: "Pallet code",
      PWMC_DESCRIPTION: "Pallet wrap material",
      NET_WEIGHT_UC: <Convert.AddUnit value={"Net weight"} unit_metric={" (kg)"} unit_imperial={" (lb)"}/>,
      SHEET_MAKING_EFFICIENCY: "Sheet making efficency",
//      SHEET_ROLL_WEIGHT: "Roll weight",
      NET_HEIGHT_UC: <Convert.AddUnit value={"Height"} unit_metric={" (mm)"} unit_imperial={" (in)"}/>
    }
    //console.log(this.commonPropertyMap);
  }



  getGrammageLabel() {
    return (
      <div style={{ display: 'inline-block' }}>Grammage (g/m<sup>2</sup>)</div>
    );
  }

  getSpec1(data) {
    if (data && data.PT_DESCRIPTION === "RULL") {
      return (
        <Row>
          <Col sm={1}>
            <Row> <Col xs={12} />&nbsp;</Row>
            <Row className="margin-bottom-40">
              <Col sm={12}>
                {data.ROLL_WIDTH_UC}
              </Col>
            </Row>

            <Row className="margin-bottom-40">
              <Col sm={12}>
                {data.ROLL_CORE_FORMAT_UC}
              </Col>
            </Row>
          </Col>

          <Col sm={5}>
            <Row> <Col xs={12} />&nbsp;</Row>
            <Row>
              <Col sm={12}>
                <img src={reelImage} alt={''} />
              </Col>
            </Row>
          </Col>
        </Row>

      );
    }
    else {
      return (
        <Row>
          <Col sm={1} className='margin-top-60'>
            {data.SHEET_HEIGHT_UC}
          </Col>
          <Col sm={5}>
            <Row>
              <Col className='margin-left-60' sm={12}>
                {data.SHEET_WIDTH_UC}
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <img src={sheetImage} alt={''} />
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }

  }

  getSpec2(data) {
    if (data && data.PT_DESCRIPTION === "RULL") {
      const definedByDiamater = (data.ROLL_BY_DIAMETER ?? '1') === '1';

      let definedBy = definedByDiamater ? 'Defined by diameter' : 'Defined by length';
      let diaclass = definedByDiamater ? 'black' : 'gray';
      
      return (
        <Row>
          <Col>
            <Row> <Col xs={5}>Wire side:</Col><Col xs={4}>{data.WIRE_SIDE}</Col></Row>
            <Row> <Col xs={5}>{<Convert.AddUnit value={definedBy} unit_metric={" (mm)"} unit_imperial={" (in)"}/>}</Col><Col></Col></Row>
            <div className={data.ROLL_BY_DIAMETER === 1 ? 'black' : 'gray'}>
              <Row> <Col xs={5} className={diaclass}>Target dia:</Col><Col xs={4}>{data.ROLL_DIAMETER_TARGET_UC}</Col></Row>
              <Row> <Col xs={5}>(+)Tolerance:</Col><Col xs={4}>{data.ROLL_DIAMETER_PTOL_UC}</Col></Row>
              <Row> <Col xs={5}>(-)Tolerance:</Col><Col xs={4}>{data.ROLL_DIAMETER_MTOL_UC}</Col></Row>
            </div>
            <div className={data.ROLL_BY_DIAMETER === 1 ? 'gray' : 'black'}>
              <Row> <Col xs={5}>Target length:</Col><Col xs={4}>{data.ROLL_LENGTH_TARGET_UC}</Col></Row>
              <Row> <Col xs={5}>(+)Tolerance:</Col><Col xs={4}>{data.ROLL_LENGTH_PTOL_UC}</Col></Row>
              <Row> <Col xs={5}>(-)Tolerance:</Col><Col xs={4}>{data.ROLL_LENGTH_MTOL_UC}</Col></Row>
            </div>
          </Col>
        </Row>
      );
    }
    else {

      return (
        <Row className="height160">
          <Col>
            <Row> <Col xs={5}>Sheets/ream:</Col><Col xs={4}>{data.SHEETS_PER_REAM}</Col></Row>
            <Row> <Col xs={5}>Stacks/pallet:</Col><Col xs={4}>{data.SHEET_STACKS_PER_PALLET}</Col></Row>
            <Row> <Col xs={5}>Sheets/carton:</Col><Col xs={4}>{data.SHEETS_PER_CARTON}</Col></Row>
            <Row> <Col xs={5}>Reams/carton:</Col><Col xs={4}>{data.REAMS_PER_CARTON}</Col></Row>
            <Row> <Col xs={5}>Sheets/pallet:</Col><Col xs={4}>{data.SHEET_TOTAL_NUMBER}</Col></Row>
            <Row> <Col xs={9} />&nbsp;</Row>
            <Row> <Col xs={9} />&nbsp;</Row>
            <Row> <Col xs={9} />&nbsp;</Row>
          </Col>
        </Row>
      );

    }

  }

  getData(data, propertyMap, show, col1Size) {
    if (!show) return null;
    const content = [];
    for (let prop in data) {
      if (data.hasOwnProperty(prop) && propertyMap.hasOwnProperty(prop)) {
        content.push(
          <Row key={prop}>
            <Col sm={col1Size}>
             {propertyMap[prop]}:
              </Col>
            <Col sm={(12 - col1Size)}>
            {prop === "BASIS_WEIGHT_UC" ? Convert.AddSymbol({check: data[prop]}) : ""}
            {data[prop]}
            </Col>
          </Row>
        )
      }
    }

    return content;
  }

  render() {
    const data = this.props.productData === undefined ? undefined : this.props.productData[0];

    if (this.props.productData === undefined) {
      return (<div className="height80"><LoadingSpinner isLoading={true} /> </div>);
    }

    else if (!data) {
      return (<div>Data missing</div>)
    }
    else {
      return (
        <Col sm={10}>
          <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); }}>
            <FormGroup>
              <Row className="row-eq-height">
                <Col xs={12}>
                  <div className="float-left min-width-400 min-height-150">
                    {this.getData(data, this.commonPropertyMap, true, 4)}
                  </div>

                  <div className="float-left min-width-200 left-border min-height-150">
                    {this.getSpec1(data)}
                  </div>

                  <div className="float-left min-width-200 min-height-200">
                    {this.getSpec2(data)}
                  </div>

                  <div className="float-left min-width-200 left-border min-height-150">
                    {this.getData(data, this.rollPropertyMap, data.PT_DESCRIPTION === "RULL", 7)}
                    {this.getData(data, this.sheetPropertyMap, data.PT_DESCRIPTION !== "RULL", 6)}
                  </div>
                </Col>
              </Row>
            </FormGroup>
          </Form>
        </Col>
      )
    }
  }
}

export default ProductInfo;